import { type Websocket } from 'entities/WebSocket'

interface IEventOrganizationProps {
  id: number | string
}

export class ChannelOrganization {
  presenceChannelName: string

  constructor(props: IEventOrganizationProps, private _websocket: Websocket) {
    this.presenceChannelName = `presence-organization.${props.id}`

    this.subscribe()
  }

  subscribe() {
    this._websocket.subscribe(this.presenceChannelName)
  }
}
